import {
  ChangeDetectionStrategy,
  Component, DoCheck, EventEmitter, Inject, OnInit, Output,
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {TaskDetailedServiceTimeModel} from "../../../models/task-detailed-service-time.model";

interface TaskDetailedServiceTimeEditDataInput {
  detailedServiceTime: any;
}

require('./task-detailed-service-time-edit.scss');
@Component({
  standalone: false,
  selector: 'app-task-detailed-service-time-edit',
  templateUrl: './task-detailed-service-time-edit.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskDetailedServiceTimeEditComponent implements OnInit {

  @Output() onClose = new EventEmitter<any>();

  detailedServiceTime: TaskDetailedServiceTimeModel;
  detailedServiceTimeCopy: TaskDetailedServiceTimeModel;

  constructor(@Inject(PANEL_DATA) public data: TaskDetailedServiceTimeEditDataInput) {
  }

  ngOnInit() {
    this.detailedServiceTime = this.data.detailedServiceTime;
    this.detailedServiceTimeCopy = {...this.detailedServiceTime};
  }

  onChangeValue(value, path) {
    this.detailedServiceTimeCopy[path] = value;
  }

  onReset() {
    this.detailedServiceTimeCopy = {...this.detailedServiceTime};
  }

  onSubmit() {
    this.onClose.emit({detailedServiceTime: this.detailedServiceTimeCopy})
  }
}
